import { render, staticRenderFns } from "./ManageAdmins.vue?vue&type=template&id=f2b71d90&"
import script from "./ManageAdmins.vue?vue&type=script&lang=js&"
export * from "./ManageAdmins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports